<template>
  <div
    class="flex w-fit items-center shrink-0"
    :style="logoStyle"
    @click="$emit('clicked')"
  >
    <img
      class="w-[28px] h-[28px]"
      src="/countly.png"
      alt="Countly Logo"
    >
  </div>
</template>

<script>
export default {
  name: 'BrandLogo',
  components: {},
  props: {
    scale: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {};
  },
  computed: {
    logoStyle() {
      return {
        transform: `scale(${this.scale})`,
      };
    },
  },
};
</script>
